export default __webpack_public_path__ + "static/media/new-icon-dashboard-appointment.6593657d.svg";